<!-- Highcarts will assume the height of it's containers as long as the div diretly containing it (chartContainer) has any kind of height specified -->
<div style="align-self:center; height: 100%; width: 100%">
  <!-- <div id="chartContainer" [chart]="chart$ | async" style="height:100%"></div> -->
  <div id="chartContainer" *ngIf="!!chart" [chart]="chart" style="height:100%"></div>
</div>

